var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":_vm.$testIds.app.root,"data-loader-count":_vm.$store.state.ui.showLoaderCount}},[(_vm.$store.state.settings.tenantSetting)?_c('router-view'):_vm._e(),(_vm.$store.state.ui.showLoaderCount>0)?_c('loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }